import { Product } from './product';

export const TargetTab = {
  BASE: 'BASE',
  ADDITIONAL: 'ADDITIONAL',
  SME: 'SME',
} as const;

export type TargetTab = (typeof TargetTab)[keyof typeof TargetTab];

export const DownloadDetail = {
  MAIN_RELEASE_DETAIL: 'MAIN_RELEASE_DETAIL',
  SERVICE_RELEASE_DETAIL: 'SERVICE_RELEASE_DETAIL',
  ADDITIONAL_SOFTWARE_DETAIL: 'ADDITIONAL_SOFTWARE_DETAIL',
  BASE_SOFTWARE_DETAIL: 'BASE_SOFTWARE_DETAIL',
} as const;

export type DownloadDetail =
  (typeof DownloadDetail)[keyof typeof DownloadDetail];

export type UriId = TargetTab | DownloadDetail;

type AdditionalSoftwareBaseData = Pick<Product, 'id' | 'name' | 'version'>;

export type AdditionalSoftwareList = Array<AdditionalSoftwareBaseData>;
